import ReactGA from 'react-ga4';
import { Autocomplete, TextField } from "@mui/material"
import { useContext } from 'react';
import CurrencyContext from "../../store/CurrencyContext";
import {useTranslation} from "react-i18next";

const CurrencySelector = () => {

    const currencyCtx = useContext(CurrencyContext)
    const selectedCurrency = currencyCtx.selectedCurrency
    const currencies = currencyCtx.loadedCurrencies
    const options = Object.keys(currencies)

    const handleChange = (_event, value) => {
        if(value !== null) currencyCtx.changeCurrency(value);

        // Track the data selection change event
        ReactGA.event({
            category: 'currency_selection',
            action: 'change_currency',
            label: value ? value.label : 'None'
        });
    }

    const { t } = useTranslation('common');
    
    return (
        <Autocomplete
            disablePortal
            openText={t('label.open')}
            closeText={t('label.close')}
            clearText={t('label.clear')}
            id="combo-box-demo"
            options={options}
            sx={{ width: 150 }}
            // filterOptions={filterOptions}
            value={selectedCurrency}
                style={{
                    // backgroundColor: 'red',
                    // overflow: 'hidden'
                }}
            onChange={handleChange}
            isOptionEqualToValue={(option, value) => option === value}
            renderInput={(params) =>
                <TextField
                    {...params}
                    // label="Select capacity"
                    label={t('offer.currency')}
                    // borderRadius="16px"
                    style={{
                        textAlign: "left",
                        color: "black"
                    }}
                />
            }
        />
    )
}

export default CurrencySelector